import axios from 'axios';
import { getLang } from './utils';

const IPDATA_KEY = 'e040a8eb9552ca02494ef5c9c95ab758615ff860d1d805c6c1a488fd';

const instance = axios.create({
    timeout: 45000, // same as backend4
    withCredentials: false,
    maxContentLength: 128 * 1024 * 1024,
    baseURL: 'https://external.forcemanager.net/api',
});

export const getLiteralsLogin = (lang) =>
    instance.get('https://fmliterals.forcemanager.net/login/v1/101/' + lang + '.json');

export const createImplementation = (token, data) =>
    instance.post('/v1/implementation?deviceType=101&clientVersion=1', data, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

export const checkImplementation = (token, tag) =>
    instance.get(`/v1/implementation/${tag}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

export const verifyCode = ({ email, code, token }) =>
    instance.post(
        '/v1/implementation/process/email/verificate',
        { email, code },
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        },
    );

export const initSignup = (body = {}) =>
    instance.post('/v1/implementation/process/email/init', { ...body, language: getLang() });

export function getGeoData() {
    return new Promise((resolve, reject) => {
        instance
            .get(`https://api.ipdata.co/?api-key=${IPDATA_KEY}`)
            .then(({ data }) => resolve(data))
            .catch(reject);
    });
}
